module.exports = __webpack_public_path__ + "static/media/cements_ultratech.848dc691.jfif";